import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import { Eye, MonitorPlay } from "lucide-react";
import { SystemDemo } from "@/components/demo/systemDemo";

const MOCK = {
  consultorio: {
    erp: [
      { name: "Agenda de consultas", kpis: [{ l: "Hoy", v: "8" }, { l: "Semana", v: "32" }], header: ["Hora", "Paciente", "Tipo"], rows: [["08:30", "María López", "Control"], ["09:15", "Jorge Andino", "Primera vez"], ["10:00", "Ana Ruiz", "Consulta"]] },
      { name: "Citas", kpis: [{ l: "Confirmadas", v: "6" }, { l: "Pendientes", v: "2" }], header: ["Paciente", "Fecha", "Estado"], rows: [["Carlos Mena", "18/09", "Confirmada"], ["Lucía Vera", "18/09", "Pendiente"], ["Pedro Soto", "19/09", "Reprogramada"]] },
      { name: "Medicinas", kpis: [{ l: "En stock", v: "84" }, { l: "Stock bajo", v: "3" }], header: ["Medicina", "Stock", "Estado"], rows: [["Paracetamol 500mg", "120", "OK"], ["Ibuprofeno 400mg", "45", "OK"], ["Amoxicilina 500mg", "8", "Bajo"]] },
    ],
    crm: [
      { name: "Pacientes", kpis: [{ l: "Activos", v: "148" }, { l: "Nuevos (mes)", v: "12" }], header: ["Paciente", "Última visita", "Estado"], rows: [["María López", "10/09", "Activo"], ["Jorge Andino", "08/09", "En tratamiento"], ["Ana Ruiz", "01/09", "Activo"]] },
      { name: "Seguimiento", funnel: ["Nuevo · 6", "En tratamiento · 14", "Control · 22", "Alta · 9"] },
      { name: "Recordatorios", kpis: [{ l: "Enviados", v: "26" }], header: ["Paciente", "Motivo", "Fecha"], rows: [["Carlos Mena", "Control anual", "20/09"], ["Lucía Vera", "Resultados", "21/09"], ["Pedro Soto", "Vacuna", "22/09"]] },
    ],
  },
  tienda: {
    erp: [
      { name: "Pedidos", kpis: [{ l: "Hoy", v: "6" }, { l: "Semana", v: "41" }], header: ["Pedido", "Cliente", "Estado"], rows: [["#1042", "Rosa Mena", "Entregado"], ["#1043", "Juan Pérez", "En camino"], ["#1044", "Lucía Vera", "Preparación"]] },
      { name: "Compras", kpis: [{ l: "Proveedores", v: "5" }], header: ["Proveedor", "Producto", "Cant."], rows: [["Flores Andinas", "Rosas", "200"], ["Vivero Quito", "Tulipanes", "80"], ["DecoHogar", "Jarrones", "35"]] },
      { name: "Stock", kpis: [{ l: "Productos", v: "64" }, { l: "Agotados", v: "2" }], header: ["Producto", "Stock", "Estado"], rows: [["Ramo rosas x12", "18", "OK"], ["Arreglo primavera", "9", "OK"], ["Tulipanes x10", "0", "Agotado"]] },
      { name: "Entregas agendadas", kpis: [{ l: "Mañana", v: "4" }], header: ["Pedido", "Zona", "Fecha"], rows: [["#1045", "Cumbayá", "18/09"], ["#1046", "Centro", "18/09"], ["#1047", "El Valle", "19/09"]] },
    ],
    crm: [
      { name: "Clientes", kpis: [{ l: "Total", v: "312" }, { l: "Frecuentes", v: "58" }], header: ["Cliente", "Última compra", "Total"], rows: [["Rosa Mena", "12/09", "$86"], ["Juan Pérez", "09/09", "$42"], ["Lucía Vera", "02/09", "$120"]] },
      { name: "Embudo de ventas", funnel: ["Nuevo · 9", "Cotizado · 5", "Pedido · 3", "Entregado · 12"] },
      { name: "Seguimiento", kpis: [{ l: "Pendientes", v: "7" }], header: ["Cliente", "Motivo", "Fecha"], rows: [["Rosa Mena", "Cotización boda", "18/09"], ["Juan Pérez", "Recompra", "19/09"], ["Ana Ruiz", "Cumpleaños", "20/09"]] },
    ],
  },
  servicios: {
    erp: [
      { name: "Proyectos", kpis: [{ l: "Activos", v: "7" }, { l: "Este mes", v: "3" }], header: ["Proyecto", "Cliente", "Estado"], rows: [["Rediseño web", "Comercial Sur", "En curso"], ["Capacitación", "Grupo Andino", "Planificado"], ["Auditoría", "TecnoEC", "Entregado"]] },
      { name: "Cotizaciones", kpis: [{ l: "Abiertas", v: "5" }], header: ["N°", "Cliente", "Valor"], rows: [["C-089", "Comercial Sur", "$1.200"], ["C-090", "Grupo Andino", "$850"], ["C-091", "TecnoEC", "$2.300"]] },
      { name: "Facturación", kpis: [{ l: "Mes", v: "$12.400" }, { l: "Pendiente", v: "$3.150" }], header: ["Factura", "Cliente", "Estado"], rows: [["F-221", "Comercial Sur", "Pagada"], ["F-222", "TecnoEC", "Pendiente"], ["F-223", "Grupo Andino", "Pagada"]] },
    ],
    crm: [
      { name: "Clientes", kpis: [{ l: "Total", v: "96" }, { l: "Nuevos (mes)", v: "8" }], header: ["Cliente", "Contacto", "Estado"], rows: [["Comercial Sur", "Ana P.", "Activo"], ["Grupo Andino", "Luis M.", "Activo"], ["TecnoEC", "Sofía R.", "Prospecto"]] },
      { name: "Oportunidades", funnel: ["Contacto · 11", "Propuesta · 6", "Negociación · 3", "Ganada · 4"] },
      { name: "Actividades", kpis: [{ l: "Semana", v: "14" }], header: ["Actividad", "Responsable", "Fecha"], rows: [["Llamada TecnoEC", "Ventas", "18/09"], ["Reunión Grupo Andino", "Ventas", "19/09"], ["Envío propuesta", "Ventas", "20/09"]] },
    ],
  },
  ganadero: {
    erp: [
      { name: "Lotes y animales", kpis: [{ l: "Cabezas", v: "342" }, { l: "Lotes", v: "8" }], header: ["Lote", "Cabezas", "Potrero", "Estado"], rows: [["A-1", "48", "Norte", "Pastoreo"], ["A-2", "35", "Sur", "Pastoreo"], ["C-3", "22", "Corral 2", "Engorde"]] },
      { name: "Sanidad y vacunas", kpis: [{ l: "Al día", v: "96%" }, { l: "Próximas", v: "12" }], header: ["Animal", "Lote", "Tratamiento", "Próx. dosis"], rows: [["Vaca #1042", "A-1", "Fiebre aftosa", "12/10"], ["Toro #208", "A-2", "Brucelosis", "15/10"], ["Vaca #1177", "C-3", "Vitamina ADE", "20/10"]] },
      { name: "Pesos y producción", kpis: [{ l: "Peso prom.", v: "420 kg" }, { l: "Ganancia", v: "0.8 kg/día" }], header: ["Animal", "Peso", "Ganancia/día"], rows: [["#1042", "452 kg", "0.9 kg"], ["#208", "610 kg", "1.1 kg"], ["#1177", "398 kg", "0.7 kg"]] },
      { name: "Ventas de ganado", kpis: [{ l: "Mes", v: "$18.500" }], header: ["Comprador", "Lote", "Cabezas", "Valor"], rows: [["Frigorífico del Valle", "B-2", "30", "$12.600"], ["Hacienda El Roble", "C-1", "8", "$5.900"]] },
    ],
    crm: [
      { name: "Compradores", kpis: [{ l: "Activos", v: "24" }], header: ["Comprador", "Tipo", "Última compra"], rows: [["Frigorífico del Valle", "Mayorista", "08/09"], ["Hacienda El Roble", "Cría", "22/08"], ["Mercado Central", "Mayorista", "15/09"]] },
      { name: "Pipeline de ventas", funnel: ["Contacto · 5", "Negociación · 3", "Venta · 2", "Entregado · 6"] },
      { name: "Seguimiento", kpis: [{ l: "Pendientes", v: "4" }], header: ["Comprador", "Motivo", "Fecha"], rows: [["Frigorífico del Valle", "Cotización lote B-3", "19/09"], ["Feria Ganadera", "Visita a hacienda", "25/09"], ["Hacienda El Roble", "Recompra crías", "28/09"]] },
    ],
  },
  turismo: {
    erp: [
      { name: "Viajes y cronogramas", kpis: [{ l: "Activos", v: "4" }, { l: "Cupos libres", v: "26" }], header: ["Viaje", "Fechas", "Cupos", "Estado"], rows: [["Galápagos 5D", "12–16 Oct", "8/12", "Confirmado"], ["Cuenca Finde", "20–22 Sep", "14/16", "Reservando"], ["Amazonía 4D", "02–05 Nov", "5/10", "Reservando"]] },
      { name: "Reservas", kpis: [{ l: "Este mes", v: "38" }], header: ["Cliente", "Viaje", "Pago", "Estado"], rows: [["Familia Cordero", "Galápagos 5D", "Pagado", "Confirmada"], ["María José P.", "Cuenca Finde", "50%", "Parcial"], ["Grupo UDLA", "Amazonía 4D", "Pendiente", "Reservada"]] },
      { name: "Pagos", kpis: [{ l: "Mes", v: "$9.840" }], header: ["Reserva", "Método", "Valor", "Estado"], rows: [["R-512", "Tarjeta", "$1.240", "Confirmado"], ["R-513", "Transferencia", "$380", "Confirmado"], ["R-514", "Tarjeta", "$620", "Pendiente"]] },
    ],
    crm: [
      { name: "Viajeros", kpis: [{ l: "Total", v: "540" }, { l: "Repiten", v: "31%" }], header: ["Cliente", "Último viaje", "Estado"], rows: [["Familia Cordero", "Galápagos", "Activo"], ["María José P.", "Cuenca", "Frecuente"], ["Carlos Mena", "Baños", "Hace 1 año"]] },
      { name: "Embudo de ventas", funnel: ["Interesado · 15", "Cotizado · 8", "Reservado · 5", "Viajó · 21"] },
      { name: "Seguimiento post-viaje", kpis: [{ l: "Encuestas", v: "17" }], header: ["Cliente", "Motivo", "Fecha"], rows: [["Familia Cordero", "Encuesta de satisfacción", "17/09"], ["María José P.", "Oferta próximo viaje", "20/09"], ["Carlos Mena", "Reactivación", "22/09"]] },
    ],
  },
};

const ModuleCard = ({ mod, color, testid }) => (
  <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm" data-testid={testid}>
    <div className="flex items-center justify-between">
      <h4 className="flex items-center gap-2 font-display text-sm font-bold text-slate-900">
        <span className="h-2 w-2 rounded-full" style={{ backgroundColor: color }} />
        {mod.name}
      </h4>
      <span className="flex items-center gap-1 rounded-full bg-slate-100 px-2 py-0.5 font-mono text-[9px] uppercase tracking-wider text-slate-400">
        <Eye className="h-2.5 w-2.5" /> Vista
      </span>
    </div>
    {mod.kpis && (
      <div className="mt-3 flex flex-wrap gap-2">
        {mod.kpis.map((k, i) => (
          <span key={i} className="rounded-md px-2.5 py-1 text-[11px] font-semibold" style={{ backgroundColor: `${color}14`, color }}>
            {k.l}: <strong>{k.v}</strong>
          </span>
        ))}
      </div>
    )}
    {mod.funnel && (
      <div className="mt-4 flex flex-wrap items-center gap-1.5">
        {mod.funnel.map((f, i) => (
          <span key={i} className="flex items-center gap-1.5">
            <span className="rounded-full px-3 py-1.5 text-[11px] font-semibold text-white" style={{ backgroundColor: color, opacity: 1 - i * 0.18 }}>
              {f}
            </span>
            {i < mod.funnel.length - 1 && <span className="text-slate-300">→</span>}
          </span>
        ))}
      </div>
    )}
    {mod.header && (
      <table className="mt-3 w-full text-left text-[11px]">
        <thead>
          <tr className="border-b border-slate-100 text-slate-400">
            {mod.header.map((h, i) => (
              <th key={i} className="pb-1.5 pr-2 font-medium">{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {mod.rows.map((r, i) => (
            <tr key={i} className="border-b border-slate-50 text-slate-600">
              {r.map((c, j) => (
                <td key={j} className="py-1.5 pr-2">{c}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    )}
  </div>
);

export const MockSystem = ({ d }) => {
  const data = MOCK[d.template] || MOCK.servicios;
  const views = [];
  if (d.show_erp) views.push({ key: "erp", label: "ERP · Gestión interna", items: data.erp });
  if (d.show_crm) views.push({ key: "crm", label: "CRM · Clientes y ventas", items: data.crm });
  const [tab, setTab] = useState(views[0]?.key);
  const [open, setOpen] = useState(false);
  if (!views.length) return null;
  const active = views.find((v) => v.key === tab) || views[0];

  return (
    <section className="border-t border-slate-100 bg-slate-50 py-16" data-testid="demo-mock-system">
      <div className="mx-auto max-w-6xl px-6">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <div>
            <h2 className="font-display text-2xl font-bold text-slate-900 sm:text-3xl">Tu sistema por dentro</h2>
            <p className="mt-1 text-sm text-slate-500">Así se verían los módulos de gestión de {d.business_name}.</p>
          </div>
          <span className="rounded-full border border-dashed px-4 py-1.5 font-mono text-[10px] uppercase tracking-[0.2em]" style={{ borderColor: d.accent_color, color: d.primary_color }}>
            Vista de demostración · datos de ejemplo
          </span>
        </div>

        <p className="mt-5 max-w-3xl rounded-lg border border-amber-200 bg-amber-50 px-4 py-2.5 text-[12px] leading-relaxed text-amber-800">
          Importante: estas pantallas son solo una referencia con datos de ejemplo. Al adquirir el producto, tu sistema no se verá exactamente así: la interfaz y los módulos se diseñan y adaptan a los procesos reales de {d.business_name}.
        </p>

        <button
          data-testid="explore-system-btn"
          onClick={() => setOpen(true)}
          className="mt-6 inline-flex items-center gap-2 rounded-full px-6 py-3 font-display text-sm font-bold text-white shadow-lg transition-transform hover:scale-[1.03]"
          style={{ backgroundColor: d.primary_color }}
        >
          <MonitorPlay className="h-4 w-4" />
          Explorar el sistema interactivo
        </button>

        {views.length > 1 && (
          <div className="mt-8 inline-flex rounded-full border border-slate-200 bg-white p-1">
            {views.map((v) => (
              <button
                key={v.key}
                data-testid={`mock-tab-${v.key}`}
                onClick={() => setTab(v.key)}
                className={`rounded-full px-5 py-2 font-display text-sm font-bold transition-colors ${tab === v.key ? "text-white" : "text-slate-500 hover:text-slate-800"}`}
                style={tab === v.key ? { backgroundColor: d.primary_color } : {}}
              >
                {v.label}
              </button>
            ))}
          </div>
        )}

        <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {active.items.map((mod, i) => (
            <ModuleCard key={i} mod={mod} color={d.primary_color} testid={`mock-module-${i}`} />
          ))}
        </div>
      </div>

      <AnimatePresence>{open && <SystemDemo demo={d} onClose={() => setOpen(false)} />}</AnimatePresence>
    </section>
  );
};
